<template>
    <div class="el-col el-col-24"> 
        <span :span="1" :offset="1"  v-show="cityVisible">{{value[0].label}}：</span>
        <el-select v-model="value[0].value" placeholder="请选择市" class="city" v-on:change="onChangeCity(value[0].value)" :span="6"  v-show="cityVisible">
            <el-option v-for="item in selectcity" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <span :span="1" :offset="1" v-show="areaVisible">{{value[1].label}}：</span>
        <el-select v-model="value[1].value" placeholder="请选择区县" class="country"  :span="6" v-show="areaVisible" @change="onChangeorg()">
            <el-option v-for="item in selectarea" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <span  :span="1" :offset="1">{{value[2].label}}：</span>
        <el-select v-model="value[2].value" placeholder="请选择幼儿园" class="org" :span="6" v-on:change="onChangekinder()" prop="orgID">
            <el-option v-for="item in kinders" :key="item.orgKindID" :label="item.fullName" :value="item.orgKindID"></el-option>
        </el-select>
         <el-button @click="get()">点击</el-button>
    </div>
</template>
<script>
import { Select} from 'element-ui'
import api from '../../../com/ajax'
import config from '../../../com/config'

// var Hub=new Vue();
export default {
  name: 'app',
    components: {
        Select
    },
    data () {
        return {
            // 对象属性
            value:[
                {label:'市',value:'',name:'provinceID'},
                {label:'区县',value:'',name:'cityID'},
                {label:'幼儿园',value:'',name:'orgID'}
            ],
            selectcity:[],//市
            selectarea:[],//区县
            kinders:[],//幼儿园
            cityVisible:false,
            areaVisible:true
        }
    },
    props:{
        value:{
            type:Array,
            default:[]
        }
    },
    watch:{
        value(val){
            this.$emit('update:value', val)
        }
        
    },
    methods:{
        get(){
            var self=this;
            alert(self.value)
        },
        onChangeCity(parentID){//省市区联动
            if(parentID>0){
                api.post(config.host + 'common/getAreasList.do', { "parentID": response.body.provinceID }).then(function (response) {
                    if(response.success){                          
                        this.value[1].value = '' 
                        this.selectarea = response.body.list;
                        this.selectarea.splice(0, 0, { 'id': '', 'name': '全部' });
                    }
                });
            }else{
                this.value[1].value = ''
                this.selectarea = [];
            }
        },
        onChangeorg(){//点击区县得到对应的幼儿园
            this.loadInt()
        },
        onChangekinder(){//得到orgID,以使后面的页面需要这个值的时候用到
            getId.$emit('change',this.value[2].value)
        },
        loadInt(){
            var that = this;
            api.get(config.host + 'org/getOrgDetail.do').then(function (response) {
                    
                if (response.success == true) {

                    if(response.body.scopeType == 1){//当前账号是省级妇保院:显示市、区县

                        that.cityVisible =true

                        that.areaVisible =true

                        api.post(config.host + 'common/getAreasList.do', { "parentID": response.body.provinceID }).then(function (response) {

                                if (response.success == true) {

                                    that.selectcity = response.body.list

                                    that.selectcity.splice(0, 0, { 'id': '', 'name': '全部' })

                                    that.selectarea=[]

                                }
                          
                        })
                        api.post(config.host + 'orgkind/getOrgKindListByArea.do', { "cityID": that.value[0].value,"countryID":that.value[1].value }).then(function (response) {

                                if (response.success == true) {

                                    that.kinders = response.body.list

                                    that.kinders.splice(0, 0, { 'id': '', 'name': '全部' })

                                }
                          
                        })
                    } else if(response.body.scopeType == 2){//当前账号是省级妇保院:隐藏市，显示区县
                        that.cityVisible =false
                        that.areaVisible =true
                        api.post(config.host + 'common/getAreasList.do', { "parentID": response.body.cityID }).then(function (response) {

                                if (response.success == true) {

                                    that.selectarea = response.body.list

                                    that.selectarea.splice(0, 0, { 'id': '', 'name': '全部' })

                                }
                          
                        })

                         api.post(config.host + 'orgkind/getOrgKindListByArea.do', { "cityID": response.body.cityID,"countryID":that.value[1].value }).then(function (response) {

                                if (response.success == true) {

                                   that.kinders = response.body.list

                                }
                          
                        })

                    }  else if(response.body.scopeType == 3){//当前账号是区级或者街道级妇保院:隐藏市、区县
                        that.cityVisible =false
                        that.areaVisible =false
                        api.post(config.host + 'orgkind/getOrgKindListByArea.do', { "countryID":response.body.countryID }).then(function (response) {

                                if (response.success == true) {

                                   that.kinders = response.body.list

                                }
                          
                        })
                    }   else if(response.body.scopeType == 4){
                        that.cityVisible =false
                        that.areaVisible =false
                        api.post(config.host + 'orgkind/getOrgKindListByArea.do').then(function (response) {

                                if (response.success == true) {

                                   that.kinders = response.body.list

                                }
                          
                        })
                    } 
                }
            })
        }
    },
    created: function(){
        this.loadInt()
    }
    
   
}
</script>


// WEBPACK FOOTER //
// src/components/reports/codeCom/yearAndclassByCityAndOrg.vue?159baedd